import styled, { css } from 'styled-components';
var ClickAndCollectWrapper = styled.div.withConfig({
  displayName: "ClickAndCollectstyles__ClickAndCollectWrapper",
  componentId: "g6r8by-0"
})(["margin-bottom:10px;"]);
var ClickAndCollectContent = styled.p.withConfig({
  displayName: "ClickAndCollectstyles__ClickAndCollectContent",
  componentId: "g6r8by-1"
})(["&&&{position:relative;font-weight:", ";", "}"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.usage === 'availability' ? css(["&&{line-height:1;margin-top:5px;margin-bottom:15px;padding-top:5px;padding-left:30px;}"]) : css(["&&{margin:0;}"]);
});
var ClickAndCollectBrand = styled.span.withConfig({
  displayName: "ClickAndCollectstyles__ClickAndCollectBrand",
  componentId: "g6r8by-2"
})(["", " ", ""], function (props) {
  return props.usage === 'availability' && css(["margin-top:5px;"]);
}, function (props) {
  return props.usage === 'storeDetails' && css(["background:purple;color:", ";display:inline-block;border-radius:3px;padding:7px 6px 3px;margin:0 5px 4px 0;"], props.theme.color.monochrome.white);
});
var ClickAndCollectBrandIcon = styled.span.withConfig({
  displayName: "ClickAndCollectstyles__ClickAndCollectBrandIcon",
  componentId: "g6r8by-3"
})(["display:inline-flex;align-items:center;justify-content:center;border-radius:3px;width:25px;height:25px;background-color:orange;vertical-align:middle;position:relative;top:-2px;margin-right:10px;", " ", ""], function (props) {
  return props.usage === 'availability' && css(["position:absolute;left:0;top:0;"]);
}, function (props) {
  return props.usage === 'storeDetails' && css(["&&&{width:18px;height:18px;background-position:center;margin-right:6px;}"]);
});
var ClickAndCollectMessage = styled.span.withConfig({
  displayName: "ClickAndCollectstyles__ClickAndCollectMessage",
  componentId: "g6r8by-4"
})(["display:inline-flex;margin-bottom:2px;"]);
export { ClickAndCollectWrapper, ClickAndCollectContent, ClickAndCollectBrand, ClickAndCollectBrandIcon, ClickAndCollectMessage };